import { createEntityHooks } from '../core/createEntityHooks'
import type { BaseDocument } from '../core/types'

/**
 * Checklist document interface
 */
export interface ChecklistDocument extends BaseDocument {
  taskId: string
  title: string | null
  sortOrder: string
}

/**
 * Checklist-specific hooks
 */
const hooks = createEntityHooks<ChecklistDocument>('checklists')

export const useChecklists = (
  filter?: Partial<ChecklistDocument>,
  options?: { enabled?: boolean },
) => {
  const { data, isLoading, db } = hooks.useEntities(filter, options)
  return { checklists: data, isLoading, db }
}

export const useChecklist = (id: string | undefined) => {
  const { data, isLoading } = hooks.useEntity(id)
  return { checklist: data, isLoading }
}

export const useChecklistMutations = () => {
  const { create, update, delete: deleteEntity } = hooks.useMutations()
  return {
    createChecklist: create,
    updateChecklist: update,
    deleteChecklist: deleteEntity,
  }
}
